import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import FilesManagement from '../../../pages/moderation/flow/files';
import ExportsTab from '../../../pages/moderation/flow/files/exportsTab';
import ImportsTab from '../../../pages/moderation/flow/files/importsTab';
import ImportDetail from '../../../pages/moderation/flow/files/importDetail';

const FilesRouter = ({ path, url, organization }) => {
    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => {
                    let redirect = `${url}/exports`;
                    if (url[url.length - 1] === '/') {
                        redirect = `${url}exports`;
                    }
                    return <Redirect to={redirect} />;
                }}
            />
            <Route
                exact
                path={`${path}/exports`}
                render={({ match }) => (
                    <FilesManagement organization={organization} flowId={match.params.flowId}>
                        <ExportsTab />
                    </FilesManagement>
                )}
            />
            <Route
                exact
                path={`${path}/imports`}
                render={({ match }) => (
                    <FilesManagement organization={organization} flowId={match.params.flowId}>
                        <ImportsTab />
                    </FilesManagement>
                )}
            />
            <Route
                exact
                path={`${path}/imports/:importId`}
                render={({ match }) => <ImportDetail organization={organization} flowId={match.params.flowId} importId={match.params.importId} />}
            />
        </Switch>
    );
};

export default FilesRouter;
